import { getIconSize } from '../utils';
import styles from './cat-success-icon.module.scss';
import cx from 'classnames';

export interface CatSuccessIconProps {
  size?: 'xl' | 'lg';
  className?: string;
}

export const CatSuccessIcon = ({ size, className }: CatSuccessIconProps) => {
  const sizeNumber = getIconSize(size);

  return (
    <svg
      width={sizeNumber}
      height={sizeNumber}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(styles['svg-styling'], className ?? '')}
      preserveAspectRatio="xMidyMid meet"
      data-testid="fitment-success-icon"
    >
      <circle cx="12" cy="12" r="11" fill="#E6F3E5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.60547 11.9995C2.60547 6.81078 6.81175 2.60449 12.0005 2.60449C17.1892 2.60449 21.3955 6.81078 21.3955 11.9995C21.3955 17.1882 17.1892 21.3945 12.0005 21.3945C6.81175 21.3945 2.60547 17.1882 2.60547 11.9995ZM12.0005 1.10449C5.98333 1.10449 1.10547 5.98235 1.10547 11.9995C1.10547 18.0166 5.98333 22.8945 12.0005 22.8945C18.0176 22.8945 22.8955 18.0166 22.8955 11.9995C22.8955 5.98235 18.0176 1.10449 12.0005 1.10449ZM17.3308 7.69555C17.5395 7.33781 17.4188 6.87855 17.0611 6.66976C16.7033 6.46097 16.244 6.58171 16.0353 6.93946L11.0247 15.5246C11.0225 15.5284 11.0195 15.5316 11.0159 15.5341C11.0124 15.5367 11.0083 15.5383 11.004 15.5391L10.9945 15.541L7.78691 12.9749C7.46346 12.7162 6.99149 12.7686 6.73274 13.0921C6.47398 13.4155 6.52642 13.8875 6.84987 14.1462L10.046 16.7032C10.2169 16.8427 10.4165 16.9428 10.6306 16.9963C10.8451 17.05 11.0688 17.0555 11.2856 17.0125C11.4998 16.9716 11.7028 16.8854 11.8809 16.7596C12.0603 16.633 12.2107 16.4686 12.3212 16.2789L17.3308 7.69555Z"
        fill="#197527"
      />
    </svg>
  );
};
